import Vue from "@/main";

let tileSetPlanClip = null;
let currentModelId;
export let graphicLayer; // 矢量图层对象

graphicLayer = new mars3d.layer.GraphicLayer();
Vue.$GLOBAL.map.addLayer(graphicLayer);

export function addPlanClipThing(modelId, positions) {
  //添加新的剖切效果
  let tilesetLayer = Vue.$GLOBAL.map.getLayer(modelId, "modelId");

  // tilesetLayer.on(mars3d.EventType.click, function (event) {
  //   console.log("单击了模型", event);
  // });

  if (tilesetLayer) {
    if (currentModelId == modelId) {
      if (tileSetPlanClip) {
        tileSetPlanClip.clear();
        tileSetPlanClip.positions = positions;
      }
    } else {
      //去除已有剖切效果
      if (tileSetPlanClip && Vue.$GLOBAL.map.hasThing(tileSetPlanClip)) {
        tileSetPlanClip.clear();
        Vue.$GLOBAL.map.removeThing(tileSetPlanClip, true);
      }
      tileSetPlanClip = new mars3d.thing.TilesetPlanClip({
        positions: positions,
        layer: tilesetLayer,
        clipOutSide: false,
        edgeColor: Cesium.Color.GREY,
        edgeWidth: 2.0,
      });

      Vue.$GLOBAL.map.addThing(tileSetPlanClip);
    }
    currentModelId = modelId;
  } else {
    // Vue.$alert("模型ID无效。", "友情提示", {
    //   confirmButtonText: "确定",
    //   type: "warning",
    //   callback: (action) => {},
    // });
    console.log("模型ID无效。");
  }
}
